import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronCircleRight } from "react-icons/fa";

const Project = () => {
  const [products, setProducts] = useState([]);
  console.log(products);
  useEffect(() => {
    fetch("https://volunteer-app-server.vercel.app/project")
      .then((res) => res.json())
      .then((data) => setProducts(data));
  }, []);
  return (
    <div id="project">
      <div className="flex justify-center">
        <h1 className="text-2xl mb-7 bg-stone-800 md:w-2/5 text-white p-2 rounded-lg">
          All Relevant Project
        </h1>
      </div>
      <div className="grid grid-cols-1 w-full md:grid-cols-2 lg:grid-cols-3 gap-7">
        {products.map((product) => (
          <Link to={`/project/${product?._id}`}>
            <div className="card  bg-base-100 shadow-xl">
              <div className="card  bg-base-100 shadow-xl">
                <figure>
                  <img className="md:h-56" src={product?.image} alt="project" />
                </figure>
                <div className="card-body">
                  <h2 className="card-title">{product?.name}</h2>
                  <p className="flex justify-start items-center ">
                    Project Details
                    <FaChevronCircleRight className="mx-1"></FaChevronCircleRight>
                  </p>
                  <div className="card-actions mt-3 justify-start">
                    <div className="bg-green-600 px-3 p-1 rounded-md text-white btn-xs">
                      <a
                        href="https://edu-with-madness.web.app/"
                        target="_blank"
                      >
                        Live Site
                      </a>
                    </div>
                    <div className="bg-emerald-500 px-3 p-1 rounded-md text-white btn-xs">
                      <a
                        href="https://github.com/emon097/Edupia-server"
                        target="_blank"
                      >
                        Server Side Code
                      </a>
                    </div>
                    <div className="bg-lime-600 px-3 p-1 rounded-md text-white mx-2 btn-xs">
                      <a
                        href="https://github.com/emon097/EduPia"
                        target="_blank"
                      >
                        Client Side Code
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Project;
